import { Group, ThemeIcon, Text } from "@mantine/core";
import classes from "./index.module.css";

import {
  IconCertificate,
  IconLockOpen2,
  IconShieldLock,
  IconMessageReply,
} from "@tabler/icons-react";

const iconMap = {
  certificate: IconCertificate,
  free: IconLockOpen2,
  security: IconShieldLock,
  response: IconMessageReply,
};

type IconName = keyof typeof iconMap;

interface IIcon {
  icon: IconName;
  title: string;
}

const FooterAnchor = ({ icon, title }: IIcon) => {
  const IconComponent = iconMap[icon];

  return (
    <Group>
      <ThemeIcon className={classes.icon} size={"lg"}>
        <IconComponent size={20} />
      </ThemeIcon>
      <Text className={classes.text}>{title}</Text>
    </Group>
  );
};

export default FooterAnchor;
